import React, { useEffect, useState } from 'react';
import App from './App';
import { LegalHubPage } from './pages/legal/LegalHubPage';
import { TermsPage } from './pages/legal/TermsPage';
import { DPAPage } from './pages/legal/DPAPage';
import { PrivacyPage } from './pages/legal/PrivacyPage';
import { CandidatesPrivacyPage } from './pages/legal/CandidatesPrivacyPage';
import { CookiesPage } from './pages/legal/CookiesPage';
import { CareersPage } from './pages/CareersPage';
import { AboutPage } from './pages/AboutPage';
export const AppRouter: React.FC = () => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Route mapping
  const routes: Record<string, React.ComponentType> = {
    '/about': AboutPage,
    '/careers': CareersPage,
    '/legal': LegalHubPage,
    '/legal/terms': TermsPage,
    '/legal/dpa': DPAPage,
    '/legal/privacy': PrivacyPage,
    '/legal/candidates-privacy': CandidatesPrivacyPage,
    '/legal/cookies': CookiesPage,
  };

  // Find matching route
  const RouteComponent = routes[currentPath];

  // If route exists, render it; otherwise render main App
  return RouteComponent ? <RouteComponent /> : <App />;
};
